const dynamicPackage = {
  detailedPlan: "תכנית מפורטת", // translated
  minimum: "מִינִימוּם", // translated
  maximum: "מַקסִימוּם", // translated
};

export default dynamicPackage;
